import { generateWbSessionRefreshToken } from '@/api/cb/contentFrontendAuthentication'
import { refreshWbSession } from '@/api/wb/authentication'
import { SecurityError } from 'common/src/errors'
import { isEnumMember } from 'common/src/utils/isEnumMember'
import { logger } from '@/logging/FrontendLogger'

let inflightRefresh: Promise<boolean> | null = null

export const attemptWbSessionRefresh = async (): Promise<boolean> => {
    if (inflightRefresh) {
        return inflightRefresh
    }

    inflightRefresh = (async () => {
        try {
            const tokenResponse = await generateWbSessionRefreshToken()
            if (!tokenResponse.data.success) {
                logger.warn(
                    `Failed to generate WB session refresh token: ${tokenResponse.data.error}`
                )
                return false
            }

            const { token, contentCreatorID } = tokenResponse.data.payload
            const refreshResponse = await refreshWbSession({
                token,
                contentCreatorID,
            })
            if (!refreshResponse.data.success) {
                logger.warn(
                    `Failed to refresh WB session: ${refreshResponse.data.error}`
                )
                return false
            }

            return true
        } catch (e) {
            logger.warn(`WB session refresh threw an error: ${e}`)
            return false
        } finally {
            inflightRefresh = null
        }
    })()

    return inflightRefresh
}

export const isWbAuthError = (error: string): boolean => {
    return isEnumMember(SecurityError, error)
}
